module.exports = __webpack_public_path__ + "static/img/vr_hy_v2_max2.e70441bb.png";